import { render, staticRenderFns } from "./MessengerUI.vue?vue&type=template&id=532e7d39&scoped=true&"
import script from "./MessengerUI.vue?vue&type=script&lang=js&"
export * from "./MessengerUI.vue?vue&type=script&lang=js&"
import style0 from "./MessengerUI.vue?vue&type=style&index=0&id=532e7d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e7d39",
  null
  
)

export default component.exports